import script from "./welcomeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./welcomeModal.vue?vue&type=script&setup=true&lang=js"

import "./welcomeModal.vue?vue&type=style&index=0&id=64b1f99f&scoped=true&lang=scss"
import "./welcomeModal.vue?vue&type=style&index=1&id=64b1f99f&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b1f99f"]])

export default __exports__